import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuth from '../auth/useAuth';

const StudentRoute = ({ element }) => {
  const { isUserAuthenticated, isStudent } = useAuth();

  return isUserAuthenticated() && isStudent() ? (
    element
  ) : (
    <Navigate to="/acc/login" replace />
  );
};

export default StudentRoute;